/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillSubscriptionsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type BackfillSubscriptionsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/backfill
 */
export interface BackfillRequestBuilder extends BaseRequestBuilder<BackfillRequestBuilder> {
    /**
     * Reads this organization's subscriptions from the billing provider and records what they pay for, for subscriptions that predate seat tracking or whose webhook never landed. Safe to run more than once.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillSubscriptionsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillSubscriptionsResponse | undefined>;
    /**
     * Reads this organization's subscriptions from the billing provider and records what they pay for, for subscriptions that predate seat tracking or whose webhook never landed. Safe to run more than once.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BackfillRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/backfill";
/**
 * Metadata for all the requests in the request builder.
 */
export const BackfillRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BackfillRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillSubscriptionsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
